module.exports = __webpack_public_path__ + "static/media/e_StatRep.51c92c16.pdf";